class LoginDelegate {
    setEmail(email) {
        this.setState({ email });
    }

    setPassword(password) {
        this.setState({ password });
    }
}

export default LoginDelegate;
